import { FileManagementPanel } from '@/components/FileManagementPanel';

export default function FileManagement() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">File Management</h1>
        <p className="text-gray-600">View and download uploaded files from customer submissions</p>
      </div>
      
      <FileManagementPanel />
    </div>
  );
}
